export default __webpack_public_path__ + "static/media/imgBannerInicioSmall.235cf472.svg";